// extracted by mini-css-extract-plugin
export default {"WaitingIcon":"battleship_WaitingIcon__xB3Fw","rotate":"battleship_rotate__tNXsa"};